var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap-btn"},[_c('a',{staticClass:"btn-blue large",on:{"click":function($event){$event.preventDefault();return _vm.changeTab.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.buttonText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }